var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8975 8.86955H14.3275C14.3405 9.0421 14.3478 9.21619 14.3478 9.39127C14.3478 10.5521 14.0577 11.6772 13.5519 12.4781C13.3958 12.7252 13.1336 13.074 12.7826 13.3093V8.86951H11.2174V13.3093C10.8664 13.074 10.6042 12.7252 10.4481 12.4781C9.94224 11.6772 9.65213 10.5521 9.65213 9.39127C9.65213 9.21619 9.65954 9.04205 9.67248 8.86955H8.10245C8.09237 9.04126 8.08688 9.21516 8.08688 9.39127C8.08688 12.6095 9.8057 15.1304 11.9999 15.1304C14.1941 15.1304 15.9129 12.6095 15.9129 9.39127C15.913 9.21516 15.9076 9.04126 15.8975 8.86955Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9565 5.73914H6.5217V6.78263H8.08691V5.73914H9.65211V6.78263H11.2173V5.73914H12.7825V6.78263H14.3477V5.73914H15.9129V6.78263H17.4781V5.73914H19.0433V6.78263H22.8091C20.8683 2.76867 16.7575 0 12 0C7.2425 0 3.1317 2.76867 1.1907 6.78263H4.9565V5.73914Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0435 17.2174V18.2609H17.4783V17.2174H15.9131V18.2609H14.3479V17.2174H12.7827V18.2609H11.2175V17.2174H9.65225V18.2609H8.08705V17.2174H6.5217V18.2609H4.9565V17.2174H1.1907C3.1317 21.2313 7.24245 24 12 24C16.7575 24 20.8683 21.2313 22.8093 17.2174H19.0435Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.d7408cfd0a78dd3f3319b15da34a58f3.svg";
export { ForwardRef as ReactComponent };